import WindowManager from '../../window-manager';
import TrackingHelper from '../helper.js'

export default function(element, data, sendTrinityEvent) {
    if (data.attributes && !data.attributes.tabId) {
        data.attributes.tabId = WindowManager.getCurrentTabId();
    }
    sendTrinityEvent(data);
}
